document.addEventListener('alpine:init', () => {
    const locale = window.locale;

    try {
        Alpine.store('news', {
            categories: [],
            totalItems: 0,
            perPage: 9,
            currentPage: 1,
            activeCategory: null,

            async fetchDataByCategory(categorySlug = this.activeCategory, categoryIndex, page = 1) {
                try {
                    this.activeCategory = categorySlug;
                    const response = await fetch(`/api/v1/news?categoryId=${categorySlug}&page=${page}&perPage=${this.perPage}`, {
                        headers: {'X-localization': locale}
                    });
                    const data = await response.json();

                    const currentPageToUse = page || this.currentPage || 1;
                    data.data.forEach(item => {
                        item.full_url = `${item.url}?page=${currentPageToUse}&categoryId=${categorySlug}`;
                    });

                    this.categories = data.data;
                    this.totalItems = data.total;
                    this.currentPage = page;
                    this.updatePagination();
                } catch (error) {
                    console.error(error);
                }
            },

            async fetchData(page = 1) {
                try {
                    const response = await fetch(`/api/v1/news?page=${page}&perPage=${this.perPage}`, {
                        headers: {'X-localization': locale}
                    });
                    const data = await response.json();

                    const currentPageToUse = page || this.currentPage || 1;
                    data.data.forEach(item => {
                        item.full_url = `${item.url}?page=${currentPageToUse}`;
                    });

                    this.categories = data.data;
                    this.totalItems = data.total;
                    this.currentPage = page;
                    this.updatePagination();
                } catch (error) {
                    console.error(error);
                }
            },

            mounted() {
                const urlParams = new URLSearchParams(window.location.search);
                const page = parseInt(urlParams.get('page')) || 1;
                const categoryId = urlParams.get('categoryId');

                this.currentPage = page;

                if (categoryId) {
                    this.activeCategory = categoryId;
                    this.fetchDataByCategory(categoryId, null, page);
                } else {
                    this.fetchData(page);
                }

                window.addEventListener('popstate', (event) => {
                    const params = new URLSearchParams(window.location.search);
                    const p = parseInt(params.get('page')) || 1;
                    const c = params.get('categoryId');

                    this.currentPage = p;
                    if (c) {
                        this.activeCategory = c;
                        this.fetchDataByCategory(c, null, p);
                    } else {
                        this.activeCategory = null;
                        this.fetchData(p);
                    }
                });
            },

            updatePagination() {
                const paginationContainer = document.querySelector('.pagination');
                paginationContainer.innerHTML = '';
                if (this.totalItems > this.perPage) {
                    this.renderPagination();
                }
            },

            generatePaginationArray() {
                const totalPages = Math.ceil(this.totalItems / this.perPage);
                if (totalPages <= 1) return [1];

                const currentPage = this.currentPage;
                const delta = 2;
                const range = [];
                const start = Math.max(2, currentPage - delta);
                const end = Math.min(totalPages - 1, currentPage + delta);

                for (let i = start; i <= end; i++) range.push(i);

                if (currentPage - delta > 2) range.unshift('...');
                if (currentPage + delta < totalPages - 1) range.push('...');

                range.unshift(1);
                if (totalPages !== 1) range.push(totalPages);

                return [...new Set(range)];
            },

            renderPagination() {
                const paginationArray = this.generatePaginationArray();
                const paginationContainer = document.querySelector('.pagination');

                paginationArray.forEach(page => {
                    if (page === '...') {
                        const dots = document.createElement('span');
                        dots.textContent = '...';
                        dots.className = 'dots';
                        paginationContainer.appendChild(dots);
                    } else {
                        const pageItem = document.createElement('div');
                        pageItem.className = `item ${page === this.currentPage ? 'item-active' : ''}`;
                        pageItem.textContent = page;
                        pageItem.addEventListener('click', () => {
                            this.currentPage = page;

                            const url = new URL(window.location);
                            url.searchParams.set('page', page);

                            if (this.activeCategory) {
                                url.searchParams.set('categoryId', this.activeCategory);
                            } else {
                                url.searchParams.delete('categoryId');
                            }

                            window.history.pushState({}, '', url)

                            setTimeout(() => {
                                window.scrollTo({
                                    top: 0,
                                    behavior: "smooth",
                                });
                            }, 0);
                            this.activeCategory
                                ? this.fetchDataByCategory(this.activeCategory, null, page)
                                : this.fetchData(page);
                        });
                        paginationContainer.appendChild(pageItem);
                    }
                });
            }
        });
    } catch (e) {
        console.log("Error", e);
    }
});
